import React from 'react';

const Loader = ({ message }) => {
    return (
        <div className="refillplans__status">
            <svg>
                <use xlinkHref="#icon-spinner7"></use>
            </svg>
            <div className="refillplans__status-message">{message}</div>
        </div>
    );
};

export default Loader;
